import { render, staticRenderFns } from "./VolunteerDiarySection.vue?vue&type=template&id=01557124&scoped=true"
import script from "./VolunteerDiarySection.vue?vue&type=script&lang=js"
export * from "./VolunteerDiarySection.vue?vue&type=script&lang=js"
import style0 from "./VolunteerDiarySection.vue?vue&type=style&index=0&id=01557124&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01557124",
  null
  
)

export default component.exports